import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import 'firebase/auth';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  currentScreen = 'order';
  static screenListener = new EventEmitter();

  constructor(private router: Router) {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
        router.navigate(['/login']);
      }
    });
  }

  ngOnInit() {
    HomeComponent.screenListener.subscribe(screen => this.currentScreen = screen);
  }

}
